import { decode } from 'html-entities'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styles from 'srcReact/SearchPage/components/styles.module.scss'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import { redirectToPage } from 'srcReact/helpers/history'
import {
  getContentWithHighlightedText,
  getHighlightedSearchContent,
  matchedSearchInterestsInArray
} from 'srcReact/helpers/utils'

const Groups = ({ id, scope, isMobile, isNative, isHeader = false, infiniteScrollRef, isBackNavigation }) => {
  const { t } = useTranslation()
  const {
    globalSearch: { searchInterestText, groups, results }
  } = useSelector((state) => state)

  let searchedGroups = groups
  if (scope === 'all') {
    searchedGroups = groups.filter((g) => g.id === id)
  }

  return (
    <div className={styles.searchContentWrapper}>
      {searchedGroups?.length > 0 &&
        searchedGroups.map((g, i) => {
          const aboutText = results.find((res) => res.id === g.id && res.information_type === 'about')

          return (
            <AnchorLink
              aria-label={t('globalSearch.accessibility.groupName', { groupName: g.name })}
              isNative={isNative}
              backNavigation={isBackNavigation}
              path={`/0/home/group/${g.id}`}
              className={`${styles.searchContent} ${(isHeader || isMobile) && styles.headerContentWrapper}`}
              key={i}
              ref={infiniteScrollRef}
              onMouseDown={(e) => e.preventDefault()}>
              <div className={styles.picture}>
                {g.picture.path ? (
                  <img src={g.picture.path} alt='' />
                ) : (
                  <img src={require('srcReact/assets/images/background-default-mixr.jpg')} alt='' />
                )}
              </div>

              <div className={styles.heading}>
                <div className={styles.titleInterests}>
                  <div
                    className={styles.title}
                    dangerouslySetInnerHTML={{
                      __html: getContentWithHighlightedText(`${decode(g.name)}`, searchInterestText)
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: getHighlightedSearchContent(
                        `${decode(g.name)}`,
                        matchedSearchInterestsInArray(g.interests, searchInterestText)
                      )
                    }}
                  />
                </div>
                {aboutText && (
                  <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{
                      __html: getContentWithHighlightedText(`${decode(aboutText.content)}`, searchInterestText, 15)
                    }}
                  />
                )}
              </div>
            </AnchorLink>
          )
        })}
    </div>
  )
}

export default Groups
